<script setup lang="ts">
defineProps<{
  title: string;
  content?: string;
  items?: { title: string; description: string }[];
  compact?: boolean;
}>();
</script>

<template>
  <section
    :class="[
      'rounded-2xl border border-slate-200 bg-white shadow-[var(--shadow-card)]',
      compact ? 'p-6 sm:p-8' : 'p-6 sm:p-10',
    ]"
  >
    <h2 class="text-2xl font-bold text-brand-900 sm:text-3xl">
      {{ title }}
    </h2>
    <p
      v-if="content"
      class="mt-4 max-w-3xl text-base leading-8 text-slate-700"
    >
      {{ content }}
    </p>
    <ul
      v-if="items?.length"
      class="mt-6 grid gap-4 sm:grid-cols-2"
    >
      <li
        v-for="item in items"
        :key="item.title"
        class="border-l-2 border-brand-500 pl-4"
      >
        <h3 class="font-semibold text-slate-900">
          {{ item.title }}
        </h3>
        <p class="mt-1 text-sm leading-6 text-slate-600">
          {{ item.description }}
        </p>
      </li>
    </ul>
  </section>
</template>
